import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";
import { isStaffUser } from "utils";
import AddIcon from "@material-ui/icons/Add";
import { PageHeader } from "frame/components";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
	menu: {
		display: "flex",
		paddingTop: theme.spacing(1),
		marginBottom: theme.spacing(-3),
	},
	addIcon: {
		marginRight: theme.spacing(1),
	},
	button: {
		padding: theme.spacing(1, 4),
		color: theme.palette.text.secondary,
		fontWeight: 600,
		"&:hover": {
			color: theme.palette.brand,
		},
		[theme.breakpoints.down("xs")]: {
			padding: theme.spacing(1, 3),
		},
	},
}));

const PageHeaderAddButton = ({
	role,
	title,
	breadcrumbs,
	addTabTitle,
	onAdd,
	staffUserHide = true,
	showAddButton,
	backActionPath,
	secondaryTabTitle,
	onSecondaryAction,
	titleAdornment,
	children,
}) => {
	const classes = useStyles();
	const showPrimary =
		typeof showAddButton === "boolean"
			? showAddButton
			: staffUserHide
				? !isStaffUser(role)
				: true;
	const showSecondary = secondaryTabTitle && onSecondaryAction;

	return (
		<PageHeader
			canGoBack
			title={title}
			breadcrumbs={breadcrumbs}
			backActionPath={backActionPath}
			titleAdornment={titleAdornment}
		>
			{children}
			{(showPrimary || showSecondary) && (
				<div className={classes.menu}>
					{showPrimary && (
						<Button
							className={classes.button}
							variant="contained"
							onClick={onAdd}
						>
							<AddIcon className={classes.addIcon} />
							{addTabTitle}
						</Button>
					)}

					{showSecondary && (
						<Button
							style={showPrimary ? { marginLeft: 20 } : undefined}
							className={classes.button}
							variant="contained"
							onClick={onSecondaryAction}
						>
							{secondaryTabTitle}
						</Button>
					)}
				</div>
			)}
		</PageHeader>
	);
};

PageHeaderAddButton.propTypes = {
	role: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	breadcrumbs: PropTypes.string,
	addTabTitle: PropTypes.string.isRequired,
	onAdd: PropTypes.func.isRequired,
	secondaryTabTitle: PropTypes.string,
	onSecondaryAction: PropTypes.func,
	staffUserHide: PropTypes.bool,
	showAddButton: PropTypes.bool,
	backActionPath: PropTypes.string,
	titleAdornment: PropTypes.node,
};

const mapStateToProps = ({ profile }) => ({
	role: profile.role,
});

export default connect(mapStateToProps)(PageHeaderAddButton);
